const US_TIME_ZONES = [
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'America/Anchorage',
    'Pacific/Honolulu',
];

const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export const getPreferredUsTimeZone = (): string => {
    const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (US_TIME_ZONES.includes(browserTimeZone)) {
        return browserTimeZone;
    }

    if (browserTimeZone?.startsWith('America/')) {
        return browserTimeZone;
    }

    // Default to Eastern time when a US timezone cannot be resolved.
    return 'America/New_York';
};

const getStableDate = (value: string | Date): Date | null => {
    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
    }

    if (DATE_ONLY_REGEX.test(value)) {
        const [year, month, day] = value.split('-').map(Number);

        // Use noon UTC for date-only values so US timezone conversion doesn't shift the day.
        return new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
    }

    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatDateUSLong = (
    value: string | Date | undefined | null,
    options?: { timeZone?: string; fallback?: string },
): string => {
    const fallback = options?.fallback ?? '-';
    if (!value) return fallback;

    const date = getStableDate(value);
    if (!date) return fallback;

    return new Intl.DateTimeFormat('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        timeZone: options?.timeZone ?? getPreferredUsTimeZone(),
    }).format(date);
};
